module.exports = __webpack_public_path__ + "static/media/online-authorize-net.94e65e3e.png";